var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondoDosNuevo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1285_2981)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1285_2981",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 704,
    y: -129,
    width: 594,
    height: 1279
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1298 1150V-129H704V1150H1298Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1285_2981)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M851.241 -147.48C851.162 -147.48 851.096 -147.48 851.017 -147.48C885.287 -135.77 919.795 -123.94 951.813 -103.94C1023.21 -59.3501 1047.84 10.2199 1054.39 110.69C1058.67 176.23 1038.7 238.97 1001.81 282.17C925.853 371.1 880.822 459.57 881.191 600.6C881.599 756.28 923.417 896.91 973.518 1035.2C992.761 1088.3 1016.9 1118.39 1049.93 1155.62H1948.15V-151.08C1759.57 -150.46 1571 -149.84 1382.42 -149.22C1205.36 -148.64 1028.3 -148.04 851.241 -147.49V-147.48Z",
    fill: "#00733A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1803.89 -129.42V1166.45H777.748C777.748 1166.45 712.421 960.7 938.338 773C1000.54 721.31 1045.4 638.83 1049.93 538.14C1054.87 428.38 1009.96 352.47 986.833 254.7C956.027 124.4 960.017 -74.5904 1077.14 -122.2C1245.9 -190.78 1803.88 -129.42 1803.88 -129.42H1803.89Z",
    fill: "#00733A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1942.71 -140.251V1155.62H916.564C916.564 1155.62 851.237 949.869 1077.15 762.169C1139.36 710.479 1184.22 628 1188.75 527.31C1193.69 417.55 1148.78 341.639 1125.65 243.869C1094.84 113.569 1098.83 -85.4205 1215.96 -133.031C1384.72 -201.611 1942.71 -140.251 1942.71 -140.251Z",
    fill: "#15A054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.61 -277C1306.03 -261.913 1283.3 -245.252 1265.88 -224.279C1239.83 -193.076 1222.81 -155.999 1212.15 -118.317C1163.73 59.1347 1250.21 234.1 1277.16 408.473C1295.12 512.623 1288.2 619.237 1240.21 716.459C1221.19 756.687 1193.23 793.432 1157.97 823.523C1123.07 853.755 1082.41 877.842 1046.27 906.701C966.016 968.777 934.733 1042.61 932.866 1136.74C931.88 1171.54 934.273 1206.33 937.271 1241C933.971 1206.33 931.288 1171.55 931.959 1136.72C933.024 1041.65 964.004 967.96 1044.54 904.948C1080.57 875.959 1120.98 851.683 1155.78 821.462C1190.69 791.561 1218.31 755.183 1237.1 715.252C1284.64 618.739 1291.24 512.292 1273.65 408.935C1246.78 234.491 1160.76 58.7557 1210.5 -118.685C1221.54 -156.413 1238.92 -193.514 1265.34 -224.635C1282.96 -245.512 1305.89 -262.067 1329.61 -276.988V-277Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1285_2981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoDosNuevo);
export default __webpack_public_path__ + "static/media/FondoDosNuevo.a6eecb9fcf35840281b804ae305b266e.svg";
export { ForwardRef as ReactComponent };